<div class="tw-w-full tw-flex-col tw-justify-center">
    <table
        class="overflow-x-auto"
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="sortAndUpdateData()"
        cdkDropList
        [cdkDropListSortPredicate]="sortPredicate"
        cdkDropListOrientation="horizontal"
        [formGroup]="filterFormGroup"
        (cdkDropListDropped)="tableDrop($event)">
        <!-- ID Column used to display icon buttons -->
        <ng-container matColumnDef="id">
            <th
                mat-header-cell
                *matHeaderCellDef
                cdkDrag
                cdkDragLockAxis="x"
                [cdkDragDisabled]="true"
                cdkDragBoundary="mat-header-row">
                <button
                    mat-icon-button
                    (click)="toggleColumnSelectionMenu()">
                    <mat-icon fontSet="material-symbols-outlined"
                        >tune
                    </mat-icon>
                </button>
                @if (showColumSelection) {
                    <mat-card class="position-fixed z-3">
                        <button
                            mat-stroked-button
                            (click)="closeColumnSelection()">
                            {{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.CONFIGURE-COLUMNS'
                                    | translate
                            }}
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                color="primary"
                                >close
                            </mat-icon>
                        </button>
                        <mat-checkbox
                            [checked]="showColumns.referenceId"
                            (change)="toggleColumnAtKey('referenceId')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.REF-ID' | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.from"
                            (change)="toggleColumnAtKey('from')"
                            >{{ 'ECMR.CONSIGNOR.ACTIVE-ECMR.FROM' | translate }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.to"
                            (change)="toggleColumnAtKey('to')"
                            >{{ 'ECMR.CONSIGNOR.ACTIVE-ECMR.TO' | translate }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.transportType"
                            (change)="toggleColumnAtKey('transportType')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.TRANSPORT-TYPE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.lastEditor"
                            (change)="toggleColumnAtKey('lastEditor')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDITOR'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.status"
                            (change)="toggleColumnAtKey('status')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.STATUS' | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.lastEditDate"
                            (change)="toggleColumnAtKey('lastEditDate')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDIT-DATE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.creationDate"
                            (change)="toggleColumnAtKey('creationDate')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.CREATION-DATE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.licensePlate"
                            (change)="toggleColumnAtKey('licensePlate')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.LICENSE-PLATE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.carrierName"
                            (change)="toggleColumnAtKey('carrierName')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-NAME'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.carrierPostCode"
                            (change)="toggleColumnAtKey('carrierPostCode')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-POST-CODE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <mat-checkbox
                            [checked]="showColumns.consigneePostCode"
                            (change)="toggleColumnAtKey('consigneePostCode')"
                            >{{
                                'ECMR.CONSIGNOR.ACTIVE-ECMR.CONSIGNEE-POST-CODE'
                                    | translate
                            }}
                        </mat-checkbox>
                        <div style="margin: 0 auto">
                            <button
                                mat-flat-button
                                color="primary"
                                style="margin: 15px"
                                (click)="updateColumns()">
                                {{ 'ECMR.COMMON.APPLY' | translate }}
                                <mat-icon
                                    fontSet="material-symbols-outlined"
                                    iconPositionEnd
                                    >check
                                </mat-icon>
                            </button>
                        </div>
                    </mat-card>
                }
            </th>
            <td
                id="icons"
                mat-cell
                *matCellDef="let ecmr; let i = index">
                @if (ecmr) {
                    <div class="tw-flex tw-items-center">
                        <button
                            mat-icon-button
                            (click)="
                                showHistoryOfEcmr(
                                    ecmr.ecmrId,
                                    ecmr.ecmrConsignment
                                        .referenceIdentificationNumber.value
                                );
                                $event.stopPropagation()
                            "
                            matTooltip="{{
                                'ECMR.overview.tooltips.history' | translate
                            }}">
                            <mat-icon fontSet="material-symbols-outlined"
                                >history
                            </mat-icon>
                        </button>
                        @if (isDcaCompliant(ecmr)) {
                            <img
                                matTooltip="{{
                                    'ECMR.ecmr_editor.dca_compliance'
                                        | translate
                                }}"
                                class="tw-h-[26px] tw-w-auto"
                                src="./assets/images/DCA.svg"
                                alt="DeCA" />
                        }
                    </div>
                }
            </td>
        </ng-container>

        <!-- Reference ID Column -->
        <ng-container matColumnDef="referenceId">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.REF-ID' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ ecmr.ecmrConsignment.referenceIdentificationNumber.value }}
            </td>
        </ng-container>

        <!-- From Column -->
        <ng-container matColumnDef="from">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.FROM' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ ecmr.ecmrConsignment.senderInformation.senderCompanyName }}
            </td>
        </ng-container>

        <!-- To Column -->
        <ng-container matColumnDef="to">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.TO' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{
                    ecmr.ecmrConsignment.consigneeInformation
                        .consigneeCompanyName
                }}
            </td>
        </ng-container>

        <!-- Transport Type Column -->
        <ng-container matColumnDef="transportType">
            <th
                mat-header-cell
                *matHeaderCellDef
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.TRANSPORT-TYPE' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ getTransportType(ecmr) }}
            </td>
        </ng-container>

        <!-- Last Editor Column -->
        <ng-container matColumnDef="lastEditor">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDITOR' | translate
                    }}</span>
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ ecmr.editedBy }}
            </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.STATUS' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                <div
                    id="status-cell"
                    class="tw-flex tw-items-center">
                    <app-ecmr-status
                        [status]="
                            ecmr ? ecmr.ecmrStatus : EcmrStatus.NEW
                        "></app-ecmr-status>
                    {{ 'ECMR.COMMON.STATUS.' + ecmr.ecmrStatus | translate }}
                </div>
            </td>
        </ng-container>

        <!-- Last Edit Date Column -->
        <ng-container matColumnDef="lastEditDate">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDIT-DATE' | translate
                    }}</span>
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index"
                (click)="showDetailsForEcmrAtIndex(i)">
                {{ dateFormatService.formatDate(ecmr.editedAt) }}
            </td>
        </ng-container>

        <!-- Creation Date Column -->
        <ng-container matColumnDef="creationDate">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.CREATION-DATE' | translate
                    }}</span>
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index"
                (click)="showDetailsForEcmrAtIndex(i)">
                {{ dateFormatService.formatDate(ecmr.createdAt) }}
            </td>
        </ng-container>

        <!-- License Plate Column-->
        <ng-container matColumnDef="licensePlate">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.LICENSE-PLATE' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{
                    ecmr.ecmrConsignment.carrierInformation
                        .vehicleConfigurationHistory | latestMotorPlate
                }}
            </td>
        </ng-container>

        <!-- Carrier Name Column-->
        <ng-container matColumnDef="carrierName">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-NAME' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ ecmr.ecmrConsignment.carrierInformation.carrierCompanyName }}
            </td>
        </ng-container>

        <!-- Carrier Postcode-->
        <ng-container matColumnDef="carrierPostCode">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-POST-CODE'
                            | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{ ecmr.ecmrConsignment.carrierInformation.carrierPostcode }}
            </td>
        </ng-container>

        <!-- Consignee Postcode-->
        <ng-container matColumnDef="consigneePostCode">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.CONSIGNOR.ACTIVE-ECMR.CONSIGNEE-POST-CODE'
                            | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let ecmr; let i = index">
                {{
                    ecmr.ecmrConsignment.consigneeInformation.consigneePostcode
                }}
            </td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
            mat-row
            *matRowDef="let row; let i = index; columns: displayedColumns"
            class="tw-cursor-pointer hover:tw-bg-gray-100"
            (click)="showDetailsForEcmrAtIndex(i)"
            id="rows"></tr>
    </table>

    <mat-paginator
        (page)="sortAndUpdateData()"
        [pageSize]="10"
        [pageSizeOptions]="[20, 50, 100]"
        showFirstLastButtons></mat-paginator>
</div>
